import React from "react";
import CustomerLogos from "../components/customerlogos";
import DottedLine from "../components/DottedLine";
import FeaturedWork from "../components/FeaturedWork";
import Header from "../components/header";
import Layout from "../components/layout";
import Testimonial from "../components/Testimonial";

export default function HomePage() {
  return (
    <Layout>
      <Header />
      <div className="container home-dotted-line">
        <DottedLine />
      </div>
      <FeaturedWork />
      <CustomerLogos />
      <Testimonial />
    </Layout>
  );
}
